(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6682"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6682"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7JAKl", function(module, exports) {

$parcel$export(module.exports, "OUTPUT_FORMATS", () => $5a193d7426028a6c$export$314b93693e42ef22);
$parcel$export(module.exports, "canEncode", () => $5a193d7426028a6c$export$32d8af07dd2de268);
$parcel$export(module.exports, "decode", () => $5a193d7426028a6c$export$2f872c0f2117be69);
$parcel$export(module.exports, "hasAlpha", () => $5a193d7426028a6c$export$7c6623716c246f1);
$parcel$export(module.exports, "sizeOf", () => $5a193d7426028a6c$export$30043de3fae42dd1);
$parcel$export(module.exports, "fitWithin", () => $5a193d7426028a6c$export$2cf9958cd81e83ad);
$parcel$export(module.exports, "draw", () => $5a193d7426028a6c$export$e529deb2bfd496dc);
$parcel$export(module.exports, "encode", () => $5a193d7426028a6c$export$c564cdbbe6da493);
$parcel$export(module.exports, "renameExtension", () => $5a193d7426028a6c$export$a7b7f54182084c78);
$parcel$export(module.exports, "saveBlob", () => $5a193d7426028a6c$export$9016c9576545678);
$parcel$export(module.exports, "formatBytes", () => $5a193d7426028a6c$export$e1a3971de07c83b5);
// Decoding, encoding and the small conveniences that both browser tools need.
//
// Everything here works on the bytes the visitor picked and never touches the
// network. That is the whole promise of /tools, so nothing in this file may
// grow a fetch of the image itself.
// Feature-detected once per page rather than per file. A browser that cannot
// encode a format answers toBlob with a PNG instead of failing, so asking for
// AVIF and trusting the result would silently hand out a mislabelled file.
const $5a193d7426028a6c$var$encoderSupport = new Map();
const $5a193d7426028a6c$export$314b93693e42ef22 = [
    {
        mime: 'image/png',
        label: 'PNG',
        extension: 'png',
        lossy: false,
        note: 'Lossless, keeps transparency'
    },
    {
        mime: 'image/jpeg',
        label: 'JPEG',
        extension: 'jpg',
        lossy: true,
        note: 'Small, no transparency'
    },
    {
        mime: 'image/webp',
        label: 'WebP',
        extension: 'webp',
        lossy: true,
        note: 'Small and keeps transparency'
    },
    {
        mime: 'image/avif',
        label: 'AVIF',
        extension: 'avif',
        lossy: true,
        note: 'Smallest, not encodable everywhere'
    }
];
function $5a193d7426028a6c$export$32d8af07dd2de268(mime) {
    if (mime === 'image/png') return Promise.resolve(true);
    if (!$5a193d7426028a6c$var$encoderSupport.has(mime)) $5a193d7426028a6c$var$encoderSupport.set(mime, new Promise((resolve)=>{
        const probe = document.createElement('canvas');
        probe.width = 1;
        probe.height = 1;
        try {
            probe.toBlob((blob)=>resolve(!!blob && blob.type === mime), mime, 0.9);
        } catch (err) {
            resolve(false);
        }
    }));
    return $5a193d7426028a6c$var$encoderSupport.get(mime);
}
async function $5a193d7426028a6c$export$2f872c0f2117be69(file) {
    if (typeof createImageBitmap === 'function') try {
        return await createImageBitmap(file, {
            imageOrientation: 'from-image'
        });
    } catch (err) {
    // Falls through. Either the format is one this browser cannot
    // decode, which the fallback will report the same way, or the
    // options argument is unsupported, which the fallback handles.
    }
    const url = URL.createObjectURL(file);
    try {
        return await new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.onerror = ()=>reject(new Error('This browser cannot decode that image'));
            img.src = url;
        });
    } finally{
        // Revoking immediately is safe: a loaded <img> keeps its own decoded
        // copy, and a failed one has nothing left to read.
        URL.revokeObjectURL(url);
    }
}
function $5a193d7426028a6c$export$7c6623716c246f1(image) {
    const PROBE = 128;
    const { width: width, height: height } = $5a193d7426028a6c$export$30043de3fae42dd1(image);
    const w = Math.max(1, Math.min(PROBE, width));
    const h = Math.max(1, Math.min(PROBE, height));
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d', {
        willReadFrequently: true
    });
    ctx.drawImage(image, 0, 0, w, h);
    const { data: data } = ctx.getImageData(0, 0, w, h);
    for(let i = 3; i < data.length; i += 4){
        if (data[i] < 255) return true;
    }
    return false;
}
function $5a193d7426028a6c$export$30043de3fae42dd1(image) {
    return {
        width: image.width || image.naturalWidth,
        height: image.height || image.naturalHeight
    };
}
function $5a193d7426028a6c$export$2cf9958cd81e83ad(width, height, maxWidth, maxHeight) {
    const scale = Math.min(maxWidth ? maxWidth / width : 1, maxHeight ? maxHeight / height : 1, 1);
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale))
    };
}
function $5a193d7426028a6c$export$e529deb2bfd496dc(image, width, height, background) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    if (background) {
        ctx.fillStyle = background;
        ctx.fillRect(0, 0, width, height);
    }
    ctx.drawImage(image, 0, 0, width, height);
    return canvas;
}
function $5a193d7426028a6c$export$c564cdbbe6da493(canvas, mime, quality) {
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error(`Could not encode as ${mime}`)), mime, // Undefined rather than a number for PNG: passing a quality to a
        // lossless encoder is meaningless, and some browsers take it as a
        // hint to switch to a lossy one.
        quality);
    });
}
function $5a193d7426028a6c$export$a7b7f54182084c78(filename, extension) {
    const stem = filename.replace(/\.[^.]+$/, '') || 'image';
    return `${stem}.${extension}`;
}
function $5a193d7426028a6c$export$9016c9576545678(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    // A revoke on the next tick rather than straight away. Chrome starts the
    // download asynchronously and reads the URL after the click returns.
    setTimeout(()=>URL.revokeObjectURL(url), 1000);
}
function $5a193d7426028a6c$export$e1a3971de07c83b5(bytes) {
    if (!bytes) return '0 B';
    const units = [
        'B',
        'KB',
        'MB',
        'GB'
    ];
    const power = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / Math.pow(1024, power);
    return `${value >= 100 || power === 0 ? Math.round(value) : value.toFixed(1)} ${units[power]}`;
}

});

parcelRegister("65gAn", function(module, exports) {

$parcel$export(module.exports, "wirePicker", () => $46e0134a81c5c949$export$a7ad1357dc53be0f);
$parcel$export(module.exports, "blockStrayDrops", () => $46e0134a81c5c949$export$9587a56f399e19d6);
$parcel$export(module.exports, "initColourPicker", () => $46e0134a81c5c949$export$54c51a5e259d1ae);
// The input controls both tools share: a drop zone that also takes a click or a
// paste, and the colour swatch picker beside it.
//
// Dropzone.js is already on the page from the header, but it exists to POST
// files somewhere. These tools must not send anything, so they take the files
// straight out of the event instead.
/**
 * Wire a drop zone.
 *
 * @param {object}   options
 * @param {Element}  options.zone      Element that accepts drops and clicks.
 * @param {Element}  options.input     The <input type="file"> behind it.
 * @param {boolean}  options.multiple  Whether more than one file is useful.
 * @param {Function} options.onFiles   Called with an array of image Files.
 * @returns {Function} Removes the paste listener, which is the only one that
 *                     outlives the elements.
 */ function $46e0134a81c5c949$export$a7ad1357dc53be0f({ zone: zone, input: input, multiple: multiple = false, onFiles: onFiles }) {
    const imagesOnly = (files)=>Array.from(files).filter((file)=>file.type.startsWith('image/'));
    // Whatever is left out is said, in a toast: the drop zone is often hidden
    // by then, and a file that silently does nothing reads as a broken tool.
    const tell = (message)=>{
        if (window.ui && typeof window.ui.toast === 'function') window.ui.toast(message, 'warning');
    };
    const hand = (files)=>{
        const all = Array.from(files);
        const images = imagesOnly(all);
        const skipped = all.length - images.length;
        if (skipped) tell(skipped === 1 && all.length === 1 ? `${all[0].name} is not an image, so there is nothing to do with it here.` : `${skipped} of ${all.length} files are not images and were left out.`);
        if (!images.length) return;
        if (!multiple && images.length > 1) tell(`This tool works on one image at a time, so only ${images[0].name} was opened.`);
        onFiles(multiple ? images : [
            images[0]
        ]);
    };
    zone.addEventListener('click', (event)=>{
        // input.click() dispatches a click that bubbles back here if the input
        // sits inside the zone, and opening the picker from its own click event
        // never stops.
        if (event.target === input) return;
        input.click();
    });
    zone.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            input.click();
        }
    });
    input.addEventListener('change', ()=>{
        hand(input.files);
        // Cleared so that picking the same file twice in a row still fires a
        // change event, which is what someone does after tweaking a setting.
        input.value = '';
    });
    // dragenter and dragleave fire for every child element the pointer crosses,
    // so a counter decides when the pointer has really left rather than the
    // events alone.
    let depth = 0;
    const setDragging = (on)=>zone.classList.toggle('is-dragging', on);
    zone.addEventListener('dragenter', (event)=>{
        event.preventDefault();
        depth += 1;
        setDragging(true);
    });
    zone.addEventListener('dragover', (event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
    });
    zone.addEventListener('dragleave', ()=>{
        depth = Math.max(0, depth - 1);
        if (depth === 0) setDragging(false);
    });
    zone.addEventListener('drop', (event)=>{
        event.preventDefault();
        depth = 0;
        setDragging(false);
        hand(event.dataTransfer.files);
    });
    // A screenshot on the clipboard is the shortest path into either tool, so
    // the whole document listens rather than only the focused zone.
    const onPaste = (event)=>{
        const files = Array.from(event.clipboardData?.files || []);
        if (files.length) {
            event.preventDefault();
            hand(files);
        }
    };
    document.addEventListener('paste', onPaste);
    return ()=>document.removeEventListener('paste', onPaste);
}
function $46e0134a81c5c949$export$9587a56f399e19d6() {
    for (const type of [
        'dragover',
        'drop'
    ])window.addEventListener(type, (event)=>{
        const target = event.target;
        if (target instanceof Element && target.closest('[data-picker-zone]')) return;
        event.preventDefault();
    });
}
function $46e0134a81c5c949$export$54c51a5e259d1ae() {
    if (typeof window.Coloris === 'undefined') return;
    window.Coloris({
        el: '[data-coloris]',
        theme: 'pill',
        themeMode: 'auto',
        alpha: false,
        swatches: [
            '#ffffff',
            '#e2e8f0',
            '#94a3b8',
            '#334155',
            '#0f172a',
            '#ef4444',
            '#f97316',
            '#f59e0b',
            '#22c55e',
            '#14b8a6',
            '#0ea5e9',
            '#3b82f6',
            '#6366f1',
            '#8b5cf6',
            '#ec4899'
        ]
    });
}

});

parcelRegister("1Euqv", function(module, exports) {

$parcel$export(module.exports, "wireAccountSave", () => $134120eb769dffbc$export$ef5aa585a850b1f);
// The one thing on these pages that leaves the machine.
//
// Everything else here is a promise that nothing is sent anywhere. This is the
// deliberate exception: a signed-in visitor presses a button and the finished
// picture is uploaded to their own account, encrypted like any other upload,
// through /upload/web rather than through anything new. That route already
// knows about plan limits, quotas, folders and the account's upload rules, and
// reusing it means a picture saved from a tool is not a second kind of upload
// with a second set of behaviours to keep in step.
//
// Because it is the exception, the button says what it does, it is never the
// default action, and nothing here runs unless it is pressed.
const $134120eb769dffbc$var$UPLOAD_URL = '/upload/web';
function $134120eb769dffbc$export$e3fbe444a169a808() {
    const node = document.getElementById('toolAccount');
    if (!node || node.dataset.loggedIn !== '1' || !node.dataset.csrf) return null;
    return {
        token: node.dataset.csrf
    };
}
/**
 * Upload one blob and answer with the link.
 *
 * The route replies with JSON on success and, depending on which check refused,
 * either JSON or a bare string on failure, so both shapes are handled rather
 * than assuming the happy one.
 */ async function $134120eb769dffbc$var$upload(blob, filename, token) {
    const form = new FormData();
    form.append('file', blob, filename);
    const response = await fetch($134120eb769dffbc$var$UPLOAD_URL, {
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': token
        },
        // Same-origin only, and the cookie is what identifies the account.
        credentials: 'same-origin',
        body: form
    });
    const raw = await response.text();
    let parsed = null;
    try {
        parsed = JSON.parse(raw);
    } catch (err) {
    // A plain-text error, which some of the checks in that route still send.
    }
    if (!response.ok) throw new Error(parsed && parsed.error || raw || `Upload failed (${response.status})`);
    if (!parsed || !parsed.url) throw new Error('The upload finished but did not come back with a link');
    return parsed.url;
}
/** One saved link, with a button that copies it. */ function $134120eb769dffbc$var$linkRow(name, url) {
    const row = document.createElement('li');
    row.className = 'flex items-center gap-3 p-3';
    row.innerHTML = `
        <i class="fa-solid fa-circle-check text-emerald-500 shrink-0"></i>
        <div class="min-w-0 flex-1">
            <p data-name class="truncate text-xs font-semibold text-slate-900 dark:text-white"></p>
            <a data-link target="_blank" rel="noopener"
               class="block truncate text-xs text-blue-600 hover:underline dark:text-blue-400"></a>
        </div>
        <button type="button" data-copy
            class="shrink-0 inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium bg-slate-100 dark:bg-gray-700 border border-slate-200 dark:border-gray-600 text-slate-700 dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-gray-600 transition-colors">
            <i class="fa-regular fa-copy"></i>
            <span>Copy</span>
        </button>`;
    row.querySelector('[data-name]').textContent = name;
    const link = row.querySelector('[data-link]');
    link.href = url;
    link.textContent = url;
    const copy = row.querySelector('[data-copy]');
    copy.addEventListener('click', async ()=>{
        try {
            await navigator.clipboard.writeText(url);
            copy.querySelector('span').textContent = 'Copied';
            setTimeout(()=>{
                copy.querySelector('span').textContent = 'Copy';
            }, 1500);
        } catch (err) {
            // Clipboard access can be refused. The link is on screen and
            // selectable either way, so this is not worth an alert.
            copy.querySelector('span').textContent = 'Press Ctrl+C';
        }
    });
    return row;
}
function $134120eb769dffbc$export$ef5aa585a850b1f({ button: button, panel: panel, list: list, error: error, collect: collect }) {
    if (!button) return false;
    const context = $134120eb769dffbc$export$e3fbe444a169a808();
    if (!context) {
        // No account, so the button would only ever produce a login redirect.
        button.hidden = true;
        return false;
    }
    button.hidden = false;
    button.addEventListener('click', async ()=>{
        const original = button.innerHTML;
        button.disabled = true;
        if (error) error.hidden = true;
        let items = [];
        try {
            items = (await collect()).filter((item)=>item && item.blob);
        } catch (err) {
            if (error) {
                error.hidden = false;
                error.textContent = err.message || 'Could not prepare the image';
            }
            button.disabled = false;
            return;
        }
        if (!items.length) {
            button.disabled = false;
            return;
        }
        // Uploaded one at a time rather than all at once: each one is a full
        // request through the encryption and storage path, and a browser that
        // opens ten of those in parallel gets rate limited by our own route.
        let saved = 0;
        try {
            for (const item of items){
                button.innerHTML = items.length > 1 ? `<i class="fa-solid fa-circle-notch fa-spin"></i> Saving ${saved + 1} of ${items.length}` : '<i class="fa-solid fa-circle-notch fa-spin"></i> Saving';
                const url = await $134120eb769dffbc$var$upload(item.blob, item.name, context.token);
                list.prepend($134120eb769dffbc$var$linkRow(item.name, url));
                panel.hidden = false;
                saved += 1;
            }
        } catch (err) {
            if (error) {
                error.hidden = false;
                error.textContent = saved ? `${saved} saved, then: ${err.message}` : err.message;
            }
        } finally{
            button.disabled = false;
            button.innerHTML = original;
        }
    });
    return true;
}

});

parcelRegister("iPsZ0", function(module, exports) {

$parcel$export(module.exports, "wireCopy", () => $db5378cf31720742$export$7167b346a0f58311);
// Putting a finished picture on the clipboard.
//
// The people these tools are for paste into Discord more often than they
// attach a file, so a copy button sits next to every "Save image" on the tools
// that produce one picture. It is a convenience on top of saving, never a
// replacement, and on a browser that cannot write images to the clipboard it
// is simply not shown.
/** Whether this browser can put an image on the clipboard at all. */ function $db5378cf31720742$export$9cdf378d4048dd07() {
    return Boolean(window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.write === 'function' && typeof window.ClipboardItem === 'function');
}
/**
 * The picture as PNG, the one image type every clipboard takes. A JPEG or WebP
 * result is drawn once more and re-encoded; nothing about it changes but the
 * container, and the saved file keeps the format that was picked.
 */ async function $db5378cf31720742$var$asPng(blob) {
    if (blob.type === 'image/png') return blob;
    const bitmap = await createImageBitmap(blob);
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    canvas.getContext('2d').drawImage(bitmap, 0, 0);
    bitmap.close();
    return new Promise((resolve, reject)=>{
        canvas.toBlob((png)=>png ? resolve(png) : reject(new Error('Could not prepare the image')), 'image/png');
    });
}
function $db5378cf31720742$var$tell(message, kind) {
    if (window.ui && typeof window.ui.toast === 'function') window.ui.toast(message, kind);
}
function $db5378cf31720742$export$7167b346a0f58311({ button: button, mirror: mirror, collect: collect }) {
    if (!button || !$db5378cf31720742$export$9cdf378d4048dd07()) return;
    button.hidden = false;
    if (mirror) {
        const follow = ()=>{
            button.disabled = mirror.disabled;
        };
        follow();
        new MutationObserver(follow).observe(mirror, {
            attributes: true,
            attributeFilter: [
                'disabled'
            ]
        });
    }
    const label = button.querySelector('[data-copy-label]');
    const idle = label ? label.textContent : '';
    button.addEventListener('click', async ()=>{
        try {
            // The item is handed a promise rather than a finished blob: the
            // write has to start inside the click, and rendering a large
            // result can take longer than a browser keeps that window open.
            const png = Promise.resolve(collect()).then((result)=>{
                if (!result || !result.blob) throw new Error('Nothing to copy yet');
                return $db5378cf31720742$var$asPng(result.blob);
            });
            await navigator.clipboard.write([
                new window.ClipboardItem({
                    'image/png': png
                })
            ]);
            if (label) {
                label.textContent = 'Copied';
                setTimeout(()=>{
                    label.textContent = idle;
                }, 1600);
            }
            $db5378cf31720742$var$tell('Image copied. Paste it wherever you need it.', 'success');
        } catch (err) {
            $db5378cf31720742$var$tell('The image could not be copied here. Use Save image instead.', 'error');
        }
    });
}

});

// Resize, crop and rotate, on /tools/resize.
//
// The arithmetic lives in tools/transform.js and is deliberately kept out of
// here: rotating a crop along with its picture and holding a shape to a ratio
// are the two things in this tool that are easy to get subtly wrong, and they
// are worth being able to test without a browser in the way.
//
// What is left here is the part that only makes sense with a pointer in it: a
// box with eight handles, drawn over the picture, that can be moved, resized,
// redrawn from scratch, and held to a shape while all of that happens.
// Rotating, cropping and resizing, as arithmetic before it is anything else.
//
// The order the three happen in is a decision, not an implementation detail.
// Somebody rotates the picture, looks at what is now in front of them, and then
// drags a box around part of it. So rotation comes first and the crop is stored
// in the coordinates of the rotated picture, which is the only way a crop can
// still mean what it looked like it meant. Resizing is last, because it changes
// how many pixels the result has and nothing about what is in it.
//
// The crop is kept as fractions of the rotated frame rather than as pixels, so
// it survives a preview at 1200 across and an export at 6000 without drifting,
// and so a rotation can carry it along instead of throwing it away.

var $7JAKl = parcelRequire("7JAKl");
const $5384670bed3e274b$export$5ad8f662811ba6cc = [
    0,
    90,
    180,
    270
];
const $5384670bed3e274b$export$219c9f5792f75787 = [
    {
        id: 'free',
        label: 'Free',
        ratio: null
    },
    {
        id: '1:1',
        label: 'Square',
        ratio: 1
    },
    {
        id: '4:3',
        label: '4:3',
        ratio: 4 / 3
    },
    {
        id: '3:2',
        label: '3:2',
        ratio: 1.5
    },
    {
        id: '16:9',
        label: '16:9',
        ratio: 16 / 9
    },
    {
        id: '9:16',
        label: '9:16',
        ratio: 9 / 16
    },
    {
        id: 'og',
        label: 'OG image',
        ratio: 1200 / 630
    }
];
const $5384670bed3e274b$export$9a265b1597029439 = {
    x: 0,
    y: 0,
    w: 1,
    h: 1
};
function $5384670bed3e274b$export$4d327d3f5401c8ff(source, rotation) {
    const quarter = (rotation % 360 + 360) % 360;
    return quarter === 90 || quarter === 270 ? {
        width: source.height,
        height: source.width
    } : {
        width: source.width,
        height: source.height
    };
}
function $5384670bed3e274b$export$69f1d4e2ff28b34d(crop) {
    const w = Math.min(1, Math.max(0.02, crop.w));
    const h = Math.min(1, Math.max(0.02, crop.h));
    return {
        x: Math.min(1 - w, Math.max(0, crop.x)),
        y: Math.min(1 - h, Math.max(0, crop.y)),
        w: w,
        h: h
    };
}
function $5384670bed3e274b$export$7e749cf8bfadf4d(crop, quarters) {
    let out = {
        ...crop
    };
    const turns = (quarters % 4 + 4) % 4;
    for(let i = 0; i < turns; i += 1)out = {
        x: 1 - (out.y + out.h),
        y: out.x,
        w: out.h,
        h: out.w
    };
    return $5384670bed3e274b$export$69f1d4e2ff28b34d(out);
}
function $5384670bed3e274b$export$3d2c2070eedca2bb(crop, horizontal) {
    return $5384670bed3e274b$export$69f1d4e2ff28b34d(horizontal ? {
        ...crop,
        x: 1 - (crop.x + crop.w)
    } : {
        ...crop,
        y: 1 - (crop.y + crop.h)
    });
}
function $5384670bed3e274b$export$b5d254f324616a9(crop, ratio, frame) {
    if (!ratio) return $5384670bed3e274b$export$69f1d4e2ff28b34d(crop);
    // The ratio is a shape on screen, so it has to be measured in pixels and
    // then turned back into fractions, or a portrait picture would get a square
    // crop that is not square.
    const pixelW = crop.w * frame.width;
    const pixelH = crop.h * frame.height;
    const current = pixelW / pixelH;
    let w = crop.w;
    let h = crop.h;
    if (current > ratio) w = pixelH * ratio / frame.width;
    else h = pixelW / ratio / frame.height;
    return $5384670bed3e274b$export$69f1d4e2ff28b34d({
        x: crop.x + (crop.w - w) / 2,
        y: crop.y + (crop.h - h) / 2,
        w: w,
        h: h
    });
}
function $5384670bed3e274b$export$d19cf40ea9cd1d20(handle, point, start, ratio, size) {
    const west = handle.includes('w');
    const east = handle.includes('e');
    const north = handle.includes('n');
    const south = handle.includes('s');
    // Edge handles keep the other axis exactly as it was, unless a shape is
    // locked, in which case it grows and shrinks around the same centre.
    if (!west && !east) {
        const anchorY = north ? start.y + start.h : start.y;
        let h = Math.abs(point.y - anchorY);
        h = Math.min(h, north ? anchorY : 1 - anchorY);
        let w = start.w;
        if (ratio) {
            w = h * size.height * ratio / size.width;
            const centre = start.x + start.w / 2;
            w = Math.min(w, 2 * Math.min(centre, 1 - centre));
            h = w * size.width / ratio / size.height;
        }
        const y = point.y < anchorY ? anchorY - h : anchorY;
        const x = ratio ? start.x + start.w / 2 - w / 2 : start.x;
        return $5384670bed3e274b$export$69f1d4e2ff28b34d({
            x: x,
            y: y,
            w: w,
            h: h
        });
    }
    if (!north && !south) {
        const anchorX = west ? start.x + start.w : start.x;
        let w = Math.abs(point.x - anchorX);
        w = Math.min(w, west ? anchorX : 1 - anchorX);
        let h = start.h;
        if (ratio) {
            h = w * size.width / ratio / size.height;
            const centre = start.y + start.h / 2;
            h = Math.min(h, 2 * Math.min(centre, 1 - centre));
            w = h * size.height * ratio / size.width;
        }
        const x = point.x < anchorX ? anchorX - w : anchorX;
        const y = ratio ? start.y + start.h / 2 - h / 2 : start.y;
        return $5384670bed3e274b$export$69f1d4e2ff28b34d({
            x: x,
            y: y,
            w: w,
            h: h
        });
    }
    // A corner: the opposite corner is the anchor.
    const anchorX = west ? start.x + start.w : start.x;
    const anchorY = north ? start.y + start.h : start.y;
    let w = Math.abs(point.x - anchorX);
    let h = Math.abs(point.y - anchorY);
    if (ratio) {
        // Follow whichever axis the pointer moved further along, so the box
        // tracks the hand rather than fighting it.
        const byWidth = w * size.width / ratio / size.height;
        if (byWidth >= h) h = byWidth;
        else w = h * size.height * ratio / size.width;
    }
    const roomX = point.x < anchorX ? anchorX : 1 - anchorX;
    const roomY = point.y < anchorY ? anchorY : 1 - anchorY;
    if (w > roomX) {
        w = roomX;
        if (ratio) h = w * size.width / ratio / size.height;
    }
    if (h > roomY) {
        h = roomY;
        if (ratio) w = h * size.height * ratio / size.width;
    }
    return $5384670bed3e274b$export$69f1d4e2ff28b34d({
        x: point.x < anchorX ? anchorX - w : anchorX,
        y: point.y < anchorY ? anchorY - h : anchorY,
        w: w,
        h: h
    });
}
function $5384670bed3e274b$export$a0ef726faed67a44(ratio, frame) {
    return $5384670bed3e274b$export$b5d254f324616a9($5384670bed3e274b$export$9a265b1597029439, ratio, frame);
}
function $5384670bed3e274b$export$421cc861b1431a7d(source, state) {
    const frame = $5384670bed3e274b$export$4d327d3f5401c8ff(source, state.rotation);
    return {
        x: Math.round(state.crop.x * frame.width),
        y: Math.round(state.crop.y * frame.height),
        width: Math.max(1, Math.round(state.crop.w * frame.width)),
        height: Math.max(1, Math.round(state.crop.h * frame.height))
    };
}
function $5384670bed3e274b$export$a4f08559803fe12c(source, state) {
    const crop = $5384670bed3e274b$export$421cc861b1431a7d(source, state);
    if (!state.resize.enabled) return {
        width: crop.width,
        height: crop.height
    };
    const width = Math.max(1, Math.round(state.resize.width || crop.width));
    const height = Math.max(1, Math.round(state.resize.height || crop.height));
    return {
        width: width,
        height: height
    };
}
function $5384670bed3e274b$export$702fa3e1016e3f75(source, state, width) {
    const crop = $5384670bed3e274b$export$421cc861b1431a7d(source, state);
    return Math.max(1, Math.round(width * crop.height / crop.width));
}
function $5384670bed3e274b$export$34a3f78c48666367(source, state, height) {
    const crop = $5384670bed3e274b$export$421cc861b1431a7d(source, state);
    return Math.max(1, Math.round(height * crop.width / crop.height));
}
function $5384670bed3e274b$export$882c99aab3e4abaf(image, state, width, height) {
    const source = (0, $7JAKl.sizeOf)(image);
    const frame = $5384670bed3e274b$export$4d327d3f5401c8ff(source, state.rotation);
    const oriented = document.createElement('canvas');
    oriented.width = frame.width;
    oriented.height = frame.height;
    const ctx = oriented.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.translate(frame.width / 2, frame.height / 2);
    ctx.rotate(state.rotation * Math.PI / 180);
    // Applied after the rotation, so "mirror" means what the person sees now
    // rather than what the file happened to hold before they turned it.
    ctx.scale(state.flipX ? -1 : 1, state.flipY ? -1 : 1);
    ctx.drawImage(image, -source.width / 2, -source.height / 2, source.width, source.height);
    const crop = $5384670bed3e274b$export$421cc861b1431a7d(source, state);
    const out = document.createElement('canvas');
    out.width = Math.max(1, Math.round(width));
    out.height = Math.max(1, Math.round(height));
    const outCtx = out.getContext('2d');
    outCtx.imageSmoothingEnabled = true;
    outCtx.imageSmoothingQuality = 'high';
    outCtx.drawImage(oriented, crop.x, crop.y, crop.width, crop.height, 0, 0, out.width, out.height);
    return out;
}
function $5384670bed3e274b$export$66ccfc01050be272(image, state, width) {
    const source = (0, $7JAKl.sizeOf)(image);
    const frame = $5384670bed3e274b$export$4d327d3f5401c8ff(source, state.rotation);
    const w = Math.max(1, Math.round(Math.min(width, frame.width)));
    const h = Math.max(1, Math.round(frame.height / frame.width * w));
    return $5384670bed3e274b$export$882c99aab3e4abaf(image, {
        ...state,
        crop: $5384670bed3e274b$export$9a265b1597029439
    }, w, h);
}



var $7JAKl = parcelRequire("7JAKl");

var $65gAn = parcelRequire("65gAn");

var $iPsZ0 = parcelRequire("iPsZ0");

var $1Euqv = parcelRequire("1Euqv");
// What the crop is drawn over. Large enough to place a box precisely, small
// enough to redraw on every pointer move without the picture lagging behind.
const $5d2711d78c370494$var$PREVIEW_WIDTH = 1100;
// Browsers refuse a canvas past roughly this and answer with a blank one rather
// than an error, so the export is held under it. See tools-screenshot.js, which
// hit the same wall from the other direction.
const $5d2711d78c370494$var$MAX_EXPORT_EDGE = 8192;
// How close a pointer has to come to a handle, in screen pixels rather than
// canvas pixels, so it feels the same on a scaled-down preview.
const $5d2711d78c370494$var$HANDLE_GRAB = 14;
const $5d2711d78c370494$var$HANDLES = [
    'nw',
    'n',
    'ne',
    'e',
    'se',
    's',
    'sw',
    'w'
];
const $5d2711d78c370494$var$FORMATS = {
    'image/png': {
        label: 'PNG',
        extension: 'png',
        quality: undefined,
        transparent: true
    },
    'image/webp': {
        label: 'WebP',
        extension: 'webp',
        quality: 0.92,
        transparent: true
    },
    'image/jpeg': {
        label: 'JPEG',
        extension: 'jpg',
        quality: 0.92,
        transparent: false
    }
};
const $5d2711d78c370494$var$el = (id)=>document.getElementById(id);
const $5d2711d78c370494$var$dom = {
    zone: $5d2711d78c370494$var$el('resizeZone'),
    input: $5d2711d78c370494$var$el('resizeInput'),
    empty: $5d2711d78c370494$var$el('resizeEmpty'),
    workspace: $5d2711d78c370494$var$el('resizeWorkspace'),
    stage: $5d2711d78c370494$var$el('resizeStage'),
    canvas: $5d2711d78c370494$var$el('resizeCanvas'),
    overlay: $5d2711d78c370494$var$el('resizeOverlay'),
    rotLeft: $5d2711d78c370494$var$el('resizeRotLeft'),
    rotRight: $5d2711d78c370494$var$el('resizeRotRight'),
    flipH: $5d2711d78c370494$var$el('resizeFlipH'),
    flipV: $5d2711d78c370494$var$el('resizeFlipV'),
    aspect: $5d2711d78c370494$var$el('resizeAspect'),
    cropReset: $5d2711d78c370494$var$el('resizeCropReset'),
    toggle: $5d2711d78c370494$var$el('resizeToggle'),
    fields: $5d2711d78c370494$var$el('resizeFields'),
    width: $5d2711d78c370494$var$el('resizeWidth'),
    height: $5d2711d78c370494$var$el('resizeHeight'),
    lock: $5d2711d78c370494$var$el('resizeLock'),
    format: $5d2711d78c370494$var$el('resizeFormat'),
    backgroundRow: $5d2711d78c370494$var$el('resizeBackgroundRow'),
    background: $5d2711d78c370494$var$el('resizeBackground'),
    meta: $5d2711d78c370494$var$el('resizeMeta'),
    error: $5d2711d78c370494$var$el('resizeError'),
    save: $5d2711d78c370494$var$el('resizeSave'),
    reset: $5d2711d78c370494$var$el('resizeReset'),
    saveAccount: $5d2711d78c370494$var$el('toolSaveAccount'),
    savePanel: $5d2711d78c370494$var$el('toolSavePanel'),
    saveList: $5d2711d78c370494$var$el('toolSaveList'),
    saveError: $5d2711d78c370494$var$el('toolSaveError')
};
const $5d2711d78c370494$var$state = {
    image: null,
    file: null,
    transparent: false,
    rotation: 0,
    flipX: false,
    flipY: false,
    crop: {
        ...(0, $5384670bed3e274b$export$9a265b1597029439)
    },
    aspect: 'free',
    resize: {
        enabled: false,
        width: 0,
        height: 0,
        lock: true
    },
    background: '#ffffff'
};
let $5d2711d78c370494$var$frame = null; // The rotated picture at preview size.
let $5d2711d78c370494$var$drag = null; // { mode, handle, start, origin }
let $5d2711d78c370494$var$hover = null; // Handle under the pointer, for the cursor.
/* ------------------------------------------------------------- geometry --- */ function $5d2711d78c370494$var$ratioOf() {
    const entry = (0, $5384670bed3e274b$export$219c9f5792f75787).find((a)=>a.id === $5d2711d78c370494$var$state.aspect);
    return entry ? entry.ratio : null;
}
function $5d2711d78c370494$var$frameSize() {
    return (0, $5384670bed3e274b$export$4d327d3f5401c8ff)((0, $7JAKl.sizeOf)($5d2711d78c370494$var$state.image), $5d2711d78c370494$var$state.rotation);
}
/** A pointer event as a position in the rotated frame, from 0 to 1. */ function $5d2711d78c370494$var$toFrame(event) {
    const rect = $5d2711d78c370494$var$dom.overlay.getBoundingClientRect();
    return {
        x: Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width)),
        y: Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height))
    };
}
/** The crop in canvas pixels of the preview. */ function $5d2711d78c370494$var$cropOnCanvas() {
    return {
        x: $5d2711d78c370494$var$state.crop.x * $5d2711d78c370494$var$dom.overlay.width,
        y: $5d2711d78c370494$var$state.crop.y * $5d2711d78c370494$var$dom.overlay.height,
        w: $5d2711d78c370494$var$state.crop.w * $5d2711d78c370494$var$dom.overlay.width,
        h: $5d2711d78c370494$var$state.crop.h * $5d2711d78c370494$var$dom.overlay.height
    };
}
function $5d2711d78c370494$var$handlePoints() {
    const r = $5d2711d78c370494$var$cropOnCanvas();
    return {
        nw: [
            r.x,
            r.y
        ],
        n: [
            r.x + r.w / 2,
            r.y
        ],
        ne: [
            r.x + r.w,
            r.y
        ],
        e: [
            r.x + r.w,
            r.y + r.h / 2
        ],
        se: [
            r.x + r.w,
            r.y + r.h
        ],
        s: [
            r.x + r.w / 2,
            r.y + r.h
        ],
        sw: [
            r.x,
            r.y + r.h
        ],
        w: [
            r.x,
            r.y + r.h / 2
        ]
    };
}
/** Which handle, if any, a pointer is over. */ function $5d2711d78c370494$var$handleAt(event) {
    const rect = $5d2711d78c370494$var$dom.overlay.getBoundingClientRect();
    if (!rect.width) return null;
    // The tolerance is a distance on screen, converted into canvas units, so
    // grabbing a corner feels identical however far the preview is scaled.
    const grab = $5d2711d78c370494$var$HANDLE_GRAB * ($5d2711d78c370494$var$dom.overlay.width / rect.width);
    const point = $5d2711d78c370494$var$toFrame(event);
    const px = point.x * $5d2711d78c370494$var$dom.overlay.width;
    const py = point.y * $5d2711d78c370494$var$dom.overlay.height;
    const points = $5d2711d78c370494$var$handlePoints();
    let best = null;
    let bestDistance = grab;
    for (const name of $5d2711d78c370494$var$HANDLES){
        const [hx, hy] = points[name];
        const distance = Math.hypot(px - hx, py - hy);
        if (distance <= bestDistance) {
            best = name;
            bestDistance = distance;
        }
    }
    return best;
}
function $5d2711d78c370494$var$insideCrop(point) {
    const c = $5d2711d78c370494$var$state.crop;
    return point.x >= c.x && point.x <= c.x + c.w && point.y >= c.y && point.y <= c.y + c.h;
}
/* -------------------------------------------------------------- drawing --- */ function $5d2711d78c370494$var$drawFrame() {
    if (!$5d2711d78c370494$var$state.image) return;
    $5d2711d78c370494$var$frame = (0, $5384670bed3e274b$export$66ccfc01050be272)($5d2711d78c370494$var$state.image, $5d2711d78c370494$var$state, $5d2711d78c370494$var$PREVIEW_WIDTH);
    $5d2711d78c370494$var$dom.canvas.width = $5d2711d78c370494$var$frame.width;
    $5d2711d78c370494$var$dom.canvas.height = $5d2711d78c370494$var$frame.height;
    $5d2711d78c370494$var$dom.canvas.getContext('2d').drawImage($5d2711d78c370494$var$frame, 0, 0);
    $5d2711d78c370494$var$dom.overlay.width = $5d2711d78c370494$var$frame.width;
    $5d2711d78c370494$var$dom.overlay.height = $5d2711d78c370494$var$frame.height;
    // The squares behind the preview mean something only where the picture
    // actually has holes in it. Behind a photograph they are just noise.
    $5d2711d78c370494$var$dom.stage.classList.toggle('is-transparent', $5d2711d78c370494$var$state.transparent);
}
function $5d2711d78c370494$var$drawOverlay() {
    if (!$5d2711d78c370494$var$frame) return;
    const ctx = $5d2711d78c370494$var$dom.overlay.getContext('2d');
    const W = $5d2711d78c370494$var$dom.overlay.width;
    const H = $5d2711d78c370494$var$dom.overlay.height;
    ctx.clearRect(0, 0, W, H);
    const r = $5d2711d78c370494$var$cropOnCanvas();
    // Everything outside the crop is dimmed, which says what will be lost
    // better than an outline on its own does.
    ctx.fillStyle = 'rgba(2, 6, 23, .55)';
    ctx.fillRect(0, 0, W, r.y);
    ctx.fillRect(0, r.y + r.h, W, H - (r.y + r.h));
    ctx.fillRect(0, r.y, r.x, r.h);
    ctx.fillRect(r.x + r.w, r.y, W - (r.x + r.w), r.h);
    const line = Math.max(1, Math.round(W / 700));
    // Thirds, faint, for placing a subject rather than for decoration.
    ctx.strokeStyle = 'rgba(255, 255, 255, .35)';
    ctx.lineWidth = line;
    ctx.beginPath();
    for(let i = 1; i < 3; i += 1){
        ctx.moveTo(r.x + r.w * i / 3, r.y);
        ctx.lineTo(r.x + r.w * i / 3, r.y + r.h);
        ctx.moveTo(r.x, r.y + r.h * i / 3);
        ctx.lineTo(r.x + r.w, r.y + r.h * i / 3);
    }
    ctx.stroke();
    ctx.strokeStyle = 'rgba(255, 255, 255, .95)';
    ctx.lineWidth = line * 2;
    ctx.strokeRect(r.x, r.y, r.w, r.h);
    const size = Math.max(6, Math.round(W / 130));
    const points = $5d2711d78c370494$var$handlePoints();
    for (const name of $5d2711d78c370494$var$HANDLES){
        const [hx, hy] = points[name];
        ctx.fillStyle = name === $5d2711d78c370494$var$hover || $5d2711d78c370494$var$drag && $5d2711d78c370494$var$drag.handle === name ? '#38bdf8' : '#ffffff';
        ctx.strokeStyle = 'rgba(2, 6, 23, .7)';
        ctx.lineWidth = line;
        ctx.beginPath();
        ctx.rect(hx - size / 2, hy - size / 2, size, size);
        ctx.fill();
        ctx.stroke();
    }
}
function $5d2711d78c370494$var$paintMeta() {
    if (!$5d2711d78c370494$var$state.image) return;
    const source = (0, $7JAKl.sizeOf)($5d2711d78c370494$var$state.image);
    const cut = (0, $5384670bed3e274b$export$421cc861b1431a7d)(source, $5d2711d78c370494$var$state);
    const out = (0, $5384670bed3e274b$export$a4f08559803fe12c)(source, $5d2711d78c370494$var$state);
    const parts = [
        `${source.width} x ${source.height} source`
    ];
    if (cut.width !== source.width || cut.height !== source.height) parts.push(`crop ${cut.width} x ${cut.height}`);
    const saved = $5d2711d78c370494$var$exportSize();
    parts.push(saved.width === out.width && saved.height === out.height ? `saves at ${out.width} x ${out.height}` : `saves at ${saved.width} x ${saved.height}, the most a browser canvas holds`);
    $5d2711d78c370494$var$dom.meta.textContent = parts.join(' - ');
}
function $5d2711d78c370494$var$redraw() {
    $5d2711d78c370494$var$drawFrame();
    $5d2711d78c370494$var$drawOverlay();
    $5d2711d78c370494$var$syncFields();
    $5d2711d78c370494$var$paintMeta();
}
/* ------------------------------------------------------------- controls --- */ function $5d2711d78c370494$var$syncFields() {
    $5d2711d78c370494$var$dom.fields.hidden = !$5d2711d78c370494$var$state.resize.enabled;
    $5d2711d78c370494$var$dom.backgroundRow.hidden = $5d2711d78c370494$var$FORMATS[$5d2711d78c370494$var$dom.format.value] ? $5d2711d78c370494$var$FORMATS[$5d2711d78c370494$var$dom.format.value].transparent || !$5d2711d78c370494$var$state.transparent : true;
    if (!$5d2711d78c370494$var$state.resize.enabled && $5d2711d78c370494$var$state.image) {
        const cut = (0, $5384670bed3e274b$export$421cc861b1431a7d)((0, $7JAKl.sizeOf)($5d2711d78c370494$var$state.image), $5d2711d78c370494$var$state);
        $5d2711d78c370494$var$state.resize.width = cut.width;
        $5d2711d78c370494$var$state.resize.height = cut.height;
        $5d2711d78c370494$var$dom.width.value = cut.width;
        $5d2711d78c370494$var$dom.height.value = cut.height;
    }
}
/** Keep the two size fields in step when the shape is locked. */ function $5d2711d78c370494$var$onWidthInput() {
    const width = Number($5d2711d78c370494$var$dom.width.value) || 0;
    $5d2711d78c370494$var$state.resize.width = width;
    if ($5d2711d78c370494$var$state.resize.lock && width > 0 && $5d2711d78c370494$var$state.image) {
        $5d2711d78c370494$var$state.resize.height = (0, $5384670bed3e274b$export$702fa3e1016e3f75)((0, $7JAKl.sizeOf)($5d2711d78c370494$var$state.image), $5d2711d78c370494$var$state, width);
        $5d2711d78c370494$var$dom.height.value = $5d2711d78c370494$var$state.resize.height;
    }
    $5d2711d78c370494$var$paintMeta();
}
function $5d2711d78c370494$var$onHeightInput() {
    const height = Number($5d2711d78c370494$var$dom.height.value) || 0;
    $5d2711d78c370494$var$state.resize.height = height;
    if ($5d2711d78c370494$var$state.resize.lock && height > 0 && $5d2711d78c370494$var$state.image) {
        $5d2711d78c370494$var$state.resize.width = (0, $5384670bed3e274b$export$34a3f78c48666367)((0, $7JAKl.sizeOf)($5d2711d78c370494$var$state.image), $5d2711d78c370494$var$state, height);
        $5d2711d78c370494$var$dom.width.value = $5d2711d78c370494$var$state.resize.width;
    }
    $5d2711d78c370494$var$paintMeta();
}
/** A preset sets the long edge and lets the other one follow. */ function $5d2711d78c370494$var$applyLongEdge(edge) {
    if (!$5d2711d78c370494$var$state.image) return;
    const cut = (0, $5384670bed3e274b$export$421cc861b1431a7d)((0, $7JAKl.sizeOf)($5d2711d78c370494$var$state.image), $5d2711d78c370494$var$state);
    $5d2711d78c370494$var$state.resize.enabled = true;
    $5d2711d78c370494$var$dom.toggle.checked = true;
    if (cut.width >= cut.height) {
        $5d2711d78c370494$var$dom.width.value = edge;
        $5d2711d78c370494$var$onWidthInput();
    } else {
        $5d2711d78c370494$var$dom.height.value = edge;
        $5d2711d78c370494$var$onHeightInput();
    }
    $5d2711d78c370494$var$syncFields();
    $5d2711d78c370494$var$paintMeta();
}
function $5d2711d78c370494$var$setAspect(id) {
    $5d2711d78c370494$var$state.aspect = id;
    const ratio = $5d2711d78c370494$var$ratioOf();
    if (ratio) $5d2711d78c370494$var$state.crop = (0, $5384670bed3e274b$export$b5d254f324616a9)($5d2711d78c370494$var$state.crop, ratio, $5d2711d78c370494$var$frameSize());
    $5d2711d78c370494$var$redraw();
}
function $5d2711d78c370494$var$rotate(quarters) {
    $5d2711d78c370494$var$state.rotation = (0, $5384670bed3e274b$export$5ad8f662811ba6cc)[(((0, $5384670bed3e274b$export$5ad8f662811ba6cc).indexOf($5d2711d78c370494$var$state.rotation) + quarters) % 4 + 4) % 4];
    $5d2711d78c370494$var$state.crop = (0, $5384670bed3e274b$export$7e749cf8bfadf4d)($5d2711d78c370494$var$state.crop, quarters);
    // The shape is expressed against the screen, so after a quarter turn the
    // crop has to be brought back to it rather than carried through sideways.
    const ratio = $5d2711d78c370494$var$ratioOf();
    if (ratio) $5d2711d78c370494$var$state.crop = (0, $5384670bed3e274b$export$b5d254f324616a9)($5d2711d78c370494$var$state.crop, ratio, $5d2711d78c370494$var$frameSize());
    $5d2711d78c370494$var$redraw();
}
function $5d2711d78c370494$var$flip(horizontal) {
    if (horizontal) $5d2711d78c370494$var$state.flipX = !$5d2711d78c370494$var$state.flipX;
    else $5d2711d78c370494$var$state.flipY = !$5d2711d78c370494$var$state.flipY;
    $5d2711d78c370494$var$state.crop = (0, $5384670bed3e274b$export$3d2c2070eedca2bb)($5d2711d78c370494$var$state.crop, horizontal);
    $5d2711d78c370494$var$redraw();
}
function $5d2711d78c370494$var$resetCrop() {
    const ratio = $5d2711d78c370494$var$ratioOf();
    $5d2711d78c370494$var$state.crop = ratio ? (0, $5384670bed3e274b$export$a0ef726faed67a44)(ratio, $5d2711d78c370494$var$frameSize()) : {
        ...(0, $5384670bed3e274b$export$9a265b1597029439)
    };
    $5d2711d78c370494$var$redraw();
}
/* ---------------------------------------------------------- interaction --- */ function $5d2711d78c370494$var$wireCropping() {
    let pointerId = null;
    $5d2711d78c370494$var$dom.overlay.addEventListener('pointermove', (event)=>{
        if (pointerId !== null) return;
        const next = $5d2711d78c370494$var$handleAt(event);
        if (next !== $5d2711d78c370494$var$hover) {
            $5d2711d78c370494$var$hover = next;
            $5d2711d78c370494$var$dom.overlay.style.cursor = next ? next === 'n' || next === 's' ? 'ns-resize' : next === 'e' || next === 'w' ? 'ew-resize' : next === 'nw' || next === 'se' ? 'nwse-resize' : 'nesw-resize' : $5d2711d78c370494$var$insideCrop($5d2711d78c370494$var$toFrame(event)) ? 'move' : 'crosshair';
            $5d2711d78c370494$var$drawOverlay();
        }
    });
    $5d2711d78c370494$var$dom.overlay.addEventListener('pointerdown', (event)=>{
        if (!$5d2711d78c370494$var$frame || event.button !== 0 && event.pointerType === 'mouse') return;
        pointerId = event.pointerId;
        $5d2711d78c370494$var$dom.overlay.setPointerCapture(pointerId);
        const point = $5d2711d78c370494$var$toFrame(event);
        const handle = $5d2711d78c370494$var$handleAt(event);
        if (handle) $5d2711d78c370494$var$drag = {
            mode: 'resize',
            handle: handle,
            start: {
                ...$5d2711d78c370494$var$state.crop
            }
        };
        else if ($5d2711d78c370494$var$insideCrop(point)) $5d2711d78c370494$var$drag = {
            mode: 'move',
            origin: point,
            start: {
                ...$5d2711d78c370494$var$state.crop
            }
        };
        else {
            $5d2711d78c370494$var$drag = {
                mode: 'draw',
                origin: point,
                start: {
                    ...$5d2711d78c370494$var$state.crop
                }
            };
            $5d2711d78c370494$var$state.crop = (0, $5384670bed3e274b$export$69f1d4e2ff28b34d)({
                x: point.x,
                y: point.y,
                w: 0.02,
                h: 0.02
            });
        }
        $5d2711d78c370494$var$drawOverlay();
    });
    $5d2711d78c370494$var$dom.overlay.addEventListener('pointermove', (event)=>{
        if (pointerId === null || event.pointerId !== pointerId || !$5d2711d78c370494$var$drag) return;
        const point = $5d2711d78c370494$var$toFrame(event);
        const ratio = $5d2711d78c370494$var$ratioOf();
        const size = $5d2711d78c370494$var$frameSize();
        if ($5d2711d78c370494$var$drag.mode === 'resize') $5d2711d78c370494$var$state.crop = (0, $5384670bed3e274b$export$d19cf40ea9cd1d20)($5d2711d78c370494$var$drag.handle, point, $5d2711d78c370494$var$drag.start, ratio, size);
        else if ($5d2711d78c370494$var$drag.mode === 'move') $5d2711d78c370494$var$state.crop = (0, $5384670bed3e274b$export$69f1d4e2ff28b34d)({
            ...$5d2711d78c370494$var$drag.start,
            x: $5d2711d78c370494$var$drag.start.x + (point.x - $5d2711d78c370494$var$drag.origin.x),
            y: $5d2711d78c370494$var$drag.start.y + (point.y - $5d2711d78c370494$var$drag.origin.y)
        });
        else // Drawing a new box behaves exactly like dragging its far corner,
        // so there is one piece of resizing logic rather than two.
        $5d2711d78c370494$var$state.crop = (0, $5384670bed3e274b$export$d19cf40ea9cd1d20)('se', point, {
            x: $5d2711d78c370494$var$drag.origin.x,
            y: $5d2711d78c370494$var$drag.origin.y,
            w: 0,
            h: 0
        }, ratio, size);
        $5d2711d78c370494$var$drawOverlay();
        $5d2711d78c370494$var$syncFields();
        $5d2711d78c370494$var$paintMeta();
    });
    const finish = (event)=>{
        if (pointerId === null || event && event.pointerId !== pointerId) return;
        try {
            $5d2711d78c370494$var$dom.overlay.releasePointerCapture(pointerId);
        } catch (err) {
        // Already released, which is the state this wanted anyway.
        }
        pointerId = null;
        $5d2711d78c370494$var$drag = null;
        $5d2711d78c370494$var$redraw();
    };
    $5d2711d78c370494$var$dom.overlay.addEventListener('pointerup', finish);
    $5d2711d78c370494$var$dom.overlay.addEventListener('pointercancel', finish);
}
/* --------------------------------------------------------------- output --- */ /** The width and height to draw at, held under what a canvas will allocate. */ function $5d2711d78c370494$var$exportSize() {
    const out = (0, $5384670bed3e274b$export$a4f08559803fe12c)((0, $7JAKl.sizeOf)($5d2711d78c370494$var$state.image), $5d2711d78c370494$var$state);
    const over = Math.max(out.width, out.height) / $5d2711d78c370494$var$MAX_EXPORT_EDGE;
    if (over <= 1) return out;
    return {
        width: Math.max(1, Math.floor(out.width / over)),
        height: Math.max(1, Math.floor(out.height / over))
    };
}
async function $5d2711d78c370494$var$renderOutput() {
    const format = $5d2711d78c370494$var$FORMATS[$5d2711d78c370494$var$dom.format.value] || $5d2711d78c370494$var$FORMATS['image/png'];
    const size = $5d2711d78c370494$var$exportSize();
    const canvas = (0, $5384670bed3e274b$export$882c99aab3e4abaf)($5d2711d78c370494$var$state.image, $5d2711d78c370494$var$state, size.width, size.height);
    // JPEG has no alpha, so anything see-through would come out as whatever the
    // encoder felt like. Filling it explicitly is the only way to know.
    let final = canvas;
    if (!format.transparent && $5d2711d78c370494$var$state.transparent) {
        const filled = document.createElement('canvas');
        filled.width = canvas.width;
        filled.height = canvas.height;
        const ctx = filled.getContext('2d');
        ctx.fillStyle = $5d2711d78c370494$var$state.background;
        ctx.fillRect(0, 0, filled.width, filled.height);
        ctx.drawImage(canvas, 0, 0);
        final = filled;
    }
    const blob = await (0, $7JAKl.encode)(final, $5d2711d78c370494$var$dom.format.value, format.quality);
    return {
        blob: blob,
        name: (0, $7JAKl.renameExtension)($5d2711d78c370494$var$state.file.name, format.extension),
        width: final.width,
        height: final.height
    };
}
async function $5d2711d78c370494$var$save() {
    if (!$5d2711d78c370494$var$state.image) return;
    $5d2711d78c370494$var$dom.save.disabled = true;
    $5d2711d78c370494$var$setError('');
    try {
        const out = await $5d2711d78c370494$var$renderOutput();
        (0, $7JAKl.saveBlob)(out.blob, out.name);
        $5d2711d78c370494$var$dom.meta.textContent = `Saved ${out.width} x ${out.height}, ${(0, $7JAKl.formatBytes)(out.blob.size)}`;
    } catch (err) {
        $5d2711d78c370494$var$setError(err.message || 'Could not render the image');
    } finally{
        $5d2711d78c370494$var$dom.save.disabled = false;
    }
}
function $5d2711d78c370494$var$setError(message) {
    $5d2711d78c370494$var$dom.error.hidden = !message;
    $5d2711d78c370494$var$dom.error.textContent = message || '';
}
/* ----------------------------------------------------------- life cycle --- */ function $5d2711d78c370494$var$reset() {
    if ($5d2711d78c370494$var$state.image && $5d2711d78c370494$var$state.image.close) $5d2711d78c370494$var$state.image.close();
    $5d2711d78c370494$var$state.image = null;
    $5d2711d78c370494$var$state.file = null;
    $5d2711d78c370494$var$state.transparent = false;
    $5d2711d78c370494$var$state.rotation = 0;
    $5d2711d78c370494$var$state.flipX = false;
    $5d2711d78c370494$var$state.flipY = false;
    $5d2711d78c370494$var$state.crop = {
        ...(0, $5384670bed3e274b$export$9a265b1597029439)
    };
    $5d2711d78c370494$var$state.resize.enabled = false;
    $5d2711d78c370494$var$frame = null;
    $5d2711d78c370494$var$drag = null;
    $5d2711d78c370494$var$hover = null;
    $5d2711d78c370494$var$dom.toggle.checked = false;
    $5d2711d78c370494$var$dom.workspace.hidden = true;
    $5d2711d78c370494$var$dom.empty.hidden = false;
    $5d2711d78c370494$var$dom.meta.textContent = '';
    $5d2711d78c370494$var$setError('');
}
async function $5d2711d78c370494$var$open([file]) {
    if (!file) return;
    $5d2711d78c370494$var$reset();
    $5d2711d78c370494$var$state.file = file;
    try {
        $5d2711d78c370494$var$state.image = await (0, $7JAKl.decode)(file);
        $5d2711d78c370494$var$state.transparent = (0, $7JAKl.hasAlpha)($5d2711d78c370494$var$state.image);
    } catch (err) {
        $5d2711d78c370494$var$setError(err.message || 'Could not read this image');
        return;
    }
    $5d2711d78c370494$var$resetCrop();
    $5d2711d78c370494$var$dom.empty.hidden = true;
    $5d2711d78c370494$var$dom.workspace.hidden = false;
    $5d2711d78c370494$var$redraw();
}
function $5d2711d78c370494$var$fillAspects() {
    $5d2711d78c370494$var$dom.aspect.innerHTML = '';
    for (const entry of (0, $5384670bed3e274b$export$219c9f5792f75787)){
        const option = document.createElement('option');
        option.value = entry.id;
        option.textContent = entry.label;
        $5d2711d78c370494$var$dom.aspect.appendChild(option);
    }
    $5d2711d78c370494$var$dom.aspect.value = $5d2711d78c370494$var$state.aspect;
}
function $5d2711d78c370494$var$init() {
    if (!$5d2711d78c370494$var$dom.zone) return;
    (0, $65gAn.blockStrayDrops)();
    (0, $65gAn.initColourPicker)();
    (0, $65gAn.wirePicker)({
        zone: $5d2711d78c370494$var$dom.zone,
        input: $5d2711d78c370494$var$dom.input,
        multiple: false,
        onFiles: $5d2711d78c370494$var$open
    });
    $5d2711d78c370494$var$wireCropping();
    $5d2711d78c370494$var$fillAspects();
    $5d2711d78c370494$var$dom.rotLeft.addEventListener('click', ()=>$5d2711d78c370494$var$rotate(-1));
    $5d2711d78c370494$var$dom.rotRight.addEventListener('click', ()=>$5d2711d78c370494$var$rotate(1));
    $5d2711d78c370494$var$dom.flipH.addEventListener('click', ()=>$5d2711d78c370494$var$flip(true));
    $5d2711d78c370494$var$dom.flipV.addEventListener('click', ()=>$5d2711d78c370494$var$flip(false));
    $5d2711d78c370494$var$dom.cropReset.addEventListener('click', $5d2711d78c370494$var$resetCrop);
    $5d2711d78c370494$var$dom.aspect.addEventListener('change', ()=>$5d2711d78c370494$var$setAspect($5d2711d78c370494$var$dom.aspect.value));
    $5d2711d78c370494$var$dom.toggle.addEventListener('change', ()=>{
        $5d2711d78c370494$var$state.resize.enabled = $5d2711d78c370494$var$dom.toggle.checked;
        $5d2711d78c370494$var$syncFields();
        $5d2711d78c370494$var$paintMeta();
    });
    $5d2711d78c370494$var$dom.width.addEventListener('input', $5d2711d78c370494$var$onWidthInput);
    $5d2711d78c370494$var$dom.height.addEventListener('input', $5d2711d78c370494$var$onHeightInput);
    $5d2711d78c370494$var$dom.lock.addEventListener('change', ()=>{
        $5d2711d78c370494$var$state.resize.lock = $5d2711d78c370494$var$dom.lock.checked;
    });
    for (const button of document.querySelectorAll('[data-long-edge]'))button.addEventListener('click', ()=>$5d2711d78c370494$var$applyLongEdge(Number(button.dataset.longEdge)));
    $5d2711d78c370494$var$dom.format.addEventListener('change', $5d2711d78c370494$var$syncFields);
    $5d2711d78c370494$var$dom.background.addEventListener('input', ()=>{
        $5d2711d78c370494$var$state.background = $5d2711d78c370494$var$dom.background.value;
    });
    $5d2711d78c370494$var$dom.save.addEventListener('click', $5d2711d78c370494$var$save);
    $5d2711d78c370494$var$dom.reset.addEventListener('click', $5d2711d78c370494$var$reset);
    (0, $iPsZ0.wireCopy)({
        button: document.getElementById('resizeCopy'),
        mirror: $5d2711d78c370494$var$dom.save,
        collect: ()=>$5d2711d78c370494$var$state.image ? $5d2711d78c370494$var$renderOutput() : null
    });
    (0, $1Euqv.wireAccountSave)({
        button: $5d2711d78c370494$var$dom.saveAccount,
        panel: $5d2711d78c370494$var$dom.savePanel,
        list: $5d2711d78c370494$var$dom.saveList,
        error: $5d2711d78c370494$var$dom.saveError,
        collect: async ()=>$5d2711d78c370494$var$state.image ? [
                await $5d2711d78c370494$var$renderOutput()
            ] : []
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $5d2711d78c370494$var$init);
else $5d2711d78c370494$var$init();

})();
//# sourceMappingURL=tools-resize.5f667f05.js.map
